// Opens the user's default maps app with the given address.
//  - iOS  → Apple Maps app (maps://)
//  - Android → default maps picker via geo: URI
//  - Desktop → Google Maps in browser
export function openInMapsApp(address) {
  const query = encodeURIComponent(address);
  const ua = navigator.userAgent || "";

  if (/iPhone|iPad|iPod/i.test(ua)) {
    window.location.href = `maps://?q=${query}`;
    return;
  }
  if (/Android/i.test(ua)) {
    window.location.href = `geo:0,0?q=${query}`;
    return;
  }
  window.open(
    `https://www.google.com/maps/search/?api=1&query=${query}`,
    "_blank",
    "noopener,noreferrer"
  );
}

export const SOCIETY_ADDRESS = "551 Merchant Street, Ambridge, PA 15003";
